module.exports = __webpack_public_path__ + "img/logo.274dbda4.png";